import { ReactNode } from "react";

interface AnnotationCardProps {
  isSelected: boolean;
  isMobile?: boolean;
  onSelect: () => void;
  children: ReactNode;
  navigation?: ReactNode; // Optional navigation controls
}

export function AnnotationCard({
  isSelected,
  isMobile = false,
  onSelect,
  children,
  navigation,
}: AnnotationCardProps) {
  // Mobile view: render content only (no border/shadow wrapper)
  if (isMobile) {
    return (
      <div className="p-2">
        {children}
        {navigation && <div className="mt-4 pb-3">{navigation}</div>}
      </div>
    );
  }

  // Desktop view: render with card wrapper
  return (
    <div
      className={`bg-white rounded-3xl shadow-lg border-2 overflow-hidden cursor-pointer transition-all duration-200 ${
        isSelected
          ? "border-primary-500 ring-2 ring-primary-200 opacity-100"
          : "border-[#ECF0F5] hover:border-primary-300 opacity-50 hover:opacity-70 -z-100"
      }`}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="p-2">{children}</div>
      {navigation && <div className="px-4 pb-2">{navigation}</div>}
    </div>
  );
}
